import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { FlyService } from '../../../../services/fly';


@Component({
  selector: 'app-createflyclient',
  templateUrl: './createflyclient.component.html',
  styleUrl: './createflyclient.component.scss'
})
export class CreateflyclientComponent {



  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _Flyclients: FlyService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
    this.initForm();
    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];
        // ✨ املا النموذج من params
        this.data.patchValue({
          name: params["name"] || '',
          address: params["address"] || '',
          phone: params["phone"] || '',
          passport_number: params["passport_number"] || '',
          trip_type: params["trip_type"] || '', // one_way | round_trip | multi_city
          trip_date: params["trip_date"] || '',
          arrival_date: params["arrival_date"] || ''
        });
      }
    });


  }

  initForm() {
    this.data = this.fb.group({
      name: ['', Validators.required],
      address: [''],
      phone: ['', Validators.required],
      passport_number: ['', Validators.required],
      trip_type: ['', Validators.required], // one_way | round_trip | multi_city
      trip_date: ['', Validators.required],
      arrival_date: [''] // مش required لأنه nullable
    });
  }


  appendPostDtata() {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      // لو القيمة Boolean، نحولها لقيمة مناسبة
      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0'); // Laravel بيفضل 1 و 0 في boolean
      } else if (value !== null && value !== undefined) {
        this.dataForm.append(key, value.toString());
      }
    });

  }



  onSubmit() {
    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._Flyclients.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء العميل" : 'Client  created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = "/flyclients";
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
       this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: err.error['message'],
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }

  onEdit() {
    this.contentReady = true;
    this._Flyclients.update(this.editId, this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل العميل" : 'Client updated',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = "/flyclients";
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل العميل" : 'Client not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }





}
